module.exports = __webpack_public_path__ + "img/arrow-up-circle.d3f9eaba.svg";